export const itemKind = item => item.product_id ? 'Finished product' : item.sku_id ? 'Child material' : 'Parent material';
export const wholeItem = item => Boolean(item?.product_id) || /^(pcs?|pieces?|sets?)$/i.test(String(item?.unit_of_measure||'').trim());
export const materialChoices = items => items.map(item=>({value:item.id,label:`${itemKind(item)} · ${item.name}${item.material_code ? ` (${item.material_code})` : ''} — ${item.unit_of_measure}`}));
export function requestLines(lines,items){
 const chosen=lines.filter(l=>l.material_id||l.requested_quantity||l.notes);
 if(!chosen.length)throw Error('Add at least one material.');
 const seen=new Set();
 return chosen.map(line=>{
  const item=items.find(i=>i.id===line.material_id);
  if(!item)throw Error('Select every material from the current list.');
  const quantity=String(line.requested_quantity??'').trim();
  if(!/^\d{1,9}(?:\.\d{1,3})?$/.test(quantity)||Number(quantity)<=0)throw Error('Enter a positive quantity with at most three decimal places.');
  if(wholeItem(item)&&!Number.isInteger(Number(quantity)))throw Error('Pieces and sets must be whole quantities.');
  const identity=item.product_id?'product:'+item.product_id:item.sku_id?'sku:'+item.sku_id:'parent:'+item.material_id;
  if(seen.has(identity))throw Error('The same item cannot be requested twice.');seen.add(identity);
  return {material_id:item.material_id||null,sku_id:item.sku_id||null,product_id:item.product_id||null,requested_quantity:Number(quantity),notes:String(line.notes||'').trim()};
 });
}
